// en, de, fr, pt
import { PATH_NAMES } from '@/assets/data/emotionhack';
export default {
    myPath: "My Path",
    myPathDesc: "MyPath brings you an exciting new way to learn & grow",
    myLibrary: "My Library",
    competencyReportModalTitle: "Competency Report",
    startLibraryCourse: "Launch Course",
    startLibraryTest: "Launch Test",
    mySuggestions: "My Suggestions",
    mySuggestionsDesc: `Got something interesting to share with everyone? Add it to the {orgName} box of knowledge`,
    mySuggestionsSubmit: "Submit a Training Item",
    pathNames: {
        [PATH_NAMES.PROFILE]: {
            heading: "Mi espejo",
            shortDescription: `Autoevaluación `,

            longDescription: "Para hacer un seguimiento de mis competencias y ver cómo me veo a mi mismo"
        },


        [PATH_NAMES.ASSESSMENT]: {
            heading: "My Mirror",
            shortDescription: "Manage Self Assessment",
            longDescription: "to update my skills as how I see myself."
        },
        [PATH_NAMES.FEEDBACK]: {
            heading: "Ejercicios individualizados",
            shortDescription: "Manage my advisor list",
            longDescription: "Para reforzar los aspectos que sean necesarios en cada caso"
        },
        [PATH_NAMES.COMPETENCIES]: {
            heading: "Revisión de competencias",
            shortDescription: "View Strength Profile",
            longDescription: "Tendrán acceso a los resultados de su test para comprobar su evolución",
        },
        [PATH_NAMES.PREFERENCES]: {
            heading: "My Preferences",
            shortDescription: "ALEX is your Adaptive Learning EXperience Manager",
            longDescription: `That understands and optimizes your learning needs
            and keeps curating your learning calendar. Many people at {orgName} have started their development journey, update your
            profile including your self-assessment, to activate ALEX
            Bot`
        },
        [PATH_NAMES.SITUATIONS]: {
            heading: "Peer Coaching",
            shortDescription: "Compare to a career challenge",
            longDescription: "Los participantes serán emparejados para que practiquen los ejercicios con sus compañeros"
        },
        [PATH_NAMES.JOURNEY]: {
            heading: "Sesión final",
            shortDescription: "Get development advice",
            longDescription: "Al concluir el peer coaching cada pareja tendrá una sesión de feedback conjunto para compartir los principales retos de la integración. "
        }
    }
}
